import _ from 'lodash';
import defaultState from 'shared/product_tabs/tab_stencils/data/defaultState';
import {
  BOTTOM_SIDE,
  COMBINED,
  PROTOTYPE_STENCIL_SLUG,
  STENCIL_BOTTOM_SIDE,
  STENCIL_TOP_SIDE,
  TOP_SIDE,
  TWO_SIDES,
  basicStencils,
} from 'shared/product_tabs/tab_stencils/data/constants';

const state = _.cloneDeep(defaultState);

if (Spree.stencils
  && Spree.stencils.length > 0
  && Spree.stencils_info
  && Spree.stencils_info.length > 0) {

  // Ordering stencils to have the top first and the bottom last
  Spree.stencils.sort((a, b) => {
    const sideA = a.parameters.stencil_side;
    const sideB = b.parameters.stencil_side;
    if (sideA === sideB) return 0;
    if (sideA === STENCIL_TOP_SIDE) return -1;
    if (sideB === STENCIL_TOP_SIDE) return 1;
    if (sideA === STENCIL_BOTTOM_SIDE) return 1;
    if (sideB === STENCIL_BOTTOM_SIDE) return -1;
    return 0;
  }).forEach((stencilData) => {
    const { product_id, variant_id, parameters, line_item_id } = stencilData;
    const product = Spree.stencils_info.find((p) => p.id === product_id);
    const variant = product.variants.find((v) => v.id === variant_id);
    const stencil = {
      product,
      variant,
      quantity: 1,
      parameters,
      line_item_id,
    };

    variant.option_values.forEach((optionValue) => {
      stencil.parameters[optionValue.option_type_name] = optionValue.name;
    });

    state.stencils.push(stencil);
    state.stencilsToBuy.push(_.cloneDeep(stencil));
  });

  // Extract global parameters from first stencil
  state.stencilsType = state.stencils[0].product.slug;
  if (Spree.stencils.length > 1) {
    state.stencilsSide = TWO_SIDES;
  } else {
    const stencilSideParameter = state.stencils[0].parameters.stencil_side;
    const side = stencilSideParameter.split(' ')[0];

    if (side.includes('Top')) {
      state.stencilsSide = TOP_SIDE;
    } else if (side.includes('Bottom')) {
      state.stencilsSide = BOTTOM_SIDE;
    } else {
      state.stencilsSide = COMBINED;
    }
  }

  const {
    part_number,
    revision,
    filename,
    panelize,
    print_confirmation,
    special_instructions,
  } = state.stencils[0].parameters;

  if (part_number) state.stencilsParameters.part_number = part_number;
  if (panelize) state.stencilsParameters.panelize = panelize;
  if (print_confirmation) state.stencilsParameters.print_confirmation = print_confirmation;
  if (revision) state.stencilsParameters.revision = revision;
  if (filename) state.stencilsParameters.filename = filename;
  if (special_instructions) state.stencilsParameters.special_instructions = special_instructions;
} else {
  state.stencilsType = PROTOTYPE_STENCIL_SLUG;
  state.stencilsSide = TOP_SIDE;

  const stencil = _.cloneDeep(basicStencils);
  stencil.product = Spree.stencils_info.find((s) => s.slug === PROTOTYPE_STENCIL_SLUG);
  stencil.parameters.stencil_side = STENCIL_TOP_SIDE;
  state.stencils.push(stencil);

  if (Spree.fabrication) {
    const { quote_parameters } = Spree.fabrication;
    state.stencilsParameters.part_number = quote_parameters.part_number;
    state.stencilsParameters.revision = quote_parameters.revision;
    state.stencilsParameters.filename = quote_parameters.filename;
  }
}

export default state;